/**
 * ============================================================================
 * SystemConfig 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义系统配置模块相关的所有枚举类型
 * - 包含：ConfigType（配置类型）, ConfigGroup（配置分组）
 * 
 * 📖 对应后端：
 * - Model: backend/app/Modules/System/Models/SystemConfig.php (常量定义)
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * 🔄 更新时机：
 * - 后端新增枚举值时
 * - 后端修改枚举值时
 * - 业务新增配置类型/分组时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Modules/System/Models/SystemConfig.php
 * 2. 找到所有 const TYPE_*, const GROUP_* 等常量定义
 * 3. 检查枚举值、名称是否与后端一致
 * 4. 检查是否有遗漏或多余的枚举值
 * 
 * @module types/system-config/enums
 * @generated AI-assisted
 * @last-updated 2025-10-18
 * ============================================================================
 */

/**
 * 配置类型枚举
 * 
 * 对应后端：SystemConfig::TYPE_* 常量
 * 
 * 定义系统配置值的数据类型，用于：
 * - 配置值的类型验证
 * - 配置表单的输入类型选择
 * - 配置值的格式化和解析
 */
export enum ConfigType {
  /** 字符串类型 */
  STRING = 'string',
  
  /** 整数类型 */
  INTEGER = 'integer',
  
  /** 浮点数类型 */
  FLOAT = 'float',
  
  /** 布尔值类型 */
  BOOLEAN = 'boolean',
  
  /** JSON类型 */
  JSON = 'json',
  
  /** 数组类型 */
  ARRAY = 'array',
}

/**
 * 配置分组枚举
 * 
 * 对应后端：SystemConfig::GROUP_* 常量
 * 
 * 定义系统配置的业务分组，用于：
 * - 配置的分类管理
 * - 配置页面的标签分组
 * - 配置的权限控制
 */
export enum ConfigGroup {
  /** 系统配置 */
  SYSTEM = 'system',
  
  /** 订单配置 */
  ORDER = 'order',
  
  /** 销售配置 */
  SALES = 'sales',
  
  /** 客户配置 */
  CUSTOMER = 'customer',
  
  /** 物料配置 */
  MATERIAL = 'material',
  
  /** 库存配置 */
  INVENTORY = 'inventory',
  
  /** 生产配置 */
  PRODUCTION = 'production',
  
  /** 质量配置 */
  QUALITY = 'quality',
  
  /** BOM配置 */
  BOM = 'bom',
  
  /** 通知配置 */
  NOTIFICATION = 'notification',
  
  /** API配置 */
  API = 'api',
  
  /** 审计配置 */
  AUDIT = 'audit',
  
  /** 文件库配置 */
  FILE = 'file',
  
  /** 安灯配置 */
  ANDON = 'andon',
  
  /** 报表配置 */
  REPORT = 'report',
  
  /** 权限配置 */
  PERMISSION = 'permission',
  
  /** 设备配置 */
  EQUIPMENT = 'equipment',
}

